import { render, staticRenderFns } from "./RedirectSaml2.vue?vue&type=template&id=edb83170&"
import script from "./RedirectSaml2.vue?vue&type=script&lang=js&"
export * from "./RedirectSaml2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports